// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-page {
  padding: 20px;
  background: #0a0f1a;
  min-height: calc(100vh - 140px);
}

.form-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.discount-form {
  background: #0f172a;
  border: 1px solid #1e293b;
  border-radius: 14px;
  padding: 18px 20px 22px;
  color: #e5e7eb;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
}

.form-field span {
  color: #cbd5e1;
  font-weight: 600;
}

.form-field input,
.form-field select,
.form-field textarea {
  background: #111827;
  border: 1px solid #1f2937;
  border-radius: 10px;
  padding: 10px 12px;
  color: #e5e7eb;
}

.form-field input[type="date"] {
  background: #ffffff;
  color: #0f172a;
  border: 1px solid #d1d5db;
}

.form-field textarea {
  resize: vertical;
}

.type-toggle {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.type-chip {
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #1f2937;
  background: #0b1324;
  color: #e5e7eb;
  cursor: pointer;
}

.type-chip.active {
  border-color: #fbbf24;
  background: #fbbf24;
  color: #0f172a;
  font-weight: 700;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.primary-btn {
  background: #22c55e;
  border: none;
  color: #0f172a;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
}

.ghost-btn {
  background: transparent;
  border: 1px solid #1f2937;
  color: #e5e7eb;
  padding: 10px 16px;
  border-radius: 10px;
  cursor: pointer;
}

.full {
  grid-column: 1 / -1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Discount/Add/FormPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".form-page {\n  padding: 20px;\n  background: #0a0f1a;\n  min-height: calc(100vh - 140px);\n}\n\n.form-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.discount-form {\n  background: #0f172a;\n  border: 1px solid #1e293b;\n  border-radius: 14px;\n  padding: 18px 20px 22px;\n  color: #e5e7eb;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 14px;\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 14px;\n}\n\n.form-field span {\n  color: #cbd5e1;\n  font-weight: 600;\n}\n\n.form-field input,\n.form-field select,\n.form-field textarea {\n  background: #111827;\n  border: 1px solid #1f2937;\n  border-radius: 10px;\n  padding: 10px 12px;\n  color: #e5e7eb;\n}\n\n.form-field input[type=\"date\"] {\n  background: #ffffff;\n  color: #0f172a;\n  border: 1px solid #d1d5db;\n}\n\n.form-field textarea {\n  resize: vertical;\n}\n\n.type-toggle {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.type-chip {\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #1f2937;\n  background: #0b1324;\n  color: #e5e7eb;\n  cursor: pointer;\n}\n\n.type-chip.active {\n  border-color: #fbbf24;\n  background: #fbbf24;\n  color: #0f172a;\n  font-weight: 700;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.primary-btn {\n  background: #22c55e;\n  border: none;\n  color: #0f172a;\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.ghost-btn {\n  background: transparent;\n  border: 1px solid #1f2937;\n  color: #e5e7eb;\n  padding: 10px 16px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.full {\n  grid-column: 1 / -1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
